import { DatePicker, RangePickerProps } from '@arco-design/web-react';
import React from 'react';

const { RangePicker } = DatePicker;

export function SelectRangeDate({
  value,
  onChange,
  showTime = { defaultValue: ['00:00', '24:00'], format: 'HH:mm' },
  ...rest
}: RangePickerProps) {
  return (
    <RangePicker
      style={{ width: '100%' }}
      value={value}
      showTime={showTime}
      onChange={onChange}
      {...rest}
    />
  );
}
